<template>
  <div class="page">
    <div class="path">
      <span class="normal pointer" @click="toEcology()">生态服务</span>
      <span class="normal space">/</span>
      <span class="normal pointer" @click="toList()">结算列表</span>
      <span class="normal space">/</span>
      <span class="active">结算详情</span>
    </div>
    <div class="content">
      <div class="title">
        <h2>
          结算详情
          <span
            class="tag"
            :class="['tag' + dataSource.ssoSupplierSettleStatus]"
            v-if="dataSource.ssoSupplierSettleStatusStr"
            >{{ dataSource.ssoSupplierSettleStatusStr }}</span
          >
        </h2>
        <div class="flex">
          <div class="info-item inline-item">
            <div class="label">申请单号:</div>
            <div class="value">
              {{ dataSource.ssoSupplierSettleOrderNo || "-" }}
            </div>
          </div>
          <div class="info-item inline-item">
            <div class="label">评审意见:</div>
            <div class="value">{{ dataSource.bpmReviewComments || "-" }}</div>
          </div>
        </div>
        <div class="flex">
          <div class="info-item inline-item">
            <div class="label">申请人:</div>
            <div class="value">{{ dataSource.createUserName || "-" }}</div>
          </div>
          <div class="info-item inline-item">
            <div class="label">申请时间:</div>
            <div class="value">{{ dataSource.createTime || "-" }}</div>
          </div>
        </div>
        <div>
          <!--1. 待提审 2. 审批中 3. 已驳回 4. 已生效 5.已取消 -->
          <el-button
            v-if="[1, 3].includes(+dataSource.ssoSupplierSettleStatus)"
            type="primary"
            size="small"
            @click="onSubmit('1')"
            >提交</el-button
          >
          <el-button
            v-if="[1, 3].includes(+dataSource.ssoSupplierSettleStatus)"
            type="dranger"
            size="small"
            @click="onSubmit('0')"
            >作 废</el-button
          >
          <el-button
            v-if="[1, 3].includes(+dataSource.ssoSupplierSettleStatus)"
            plain
            size="small"
            @click="onEdit()"
            >编 辑</el-button
          >
        </div>
      </div>
      <div>
        <h3>申请信息</h3>
        <div>
          <div class="info-item">
            <div class="label">项目名称:</div>
            <div class="value">
              {{ dataSource.projectName || "-" }}
            </div>
          </div>
          <div class="info-item">
            <div class="label">项目经理:</div>
            <div class="value">
              {{ dataSource.projectManager || "-" }}
            </div>
          </div>
          <div class="info-item">
            <div class="label">申请单号:</div>
            <div class="value">
              {{ dataSource.demandTableNo || "-" }}
            </div>
          </div>
          <h3>报工明细</h3>
          <div>
            <Table
              ref="reportTable"
              class="table"
              :tableConfig="reportTableConfig"
            >
            </Table>
          </div>
          <h3>交通费明细</h3>
          <div>
            <Table ref="costTable" class="table" :tableConfig="costTableConfig">
              <template :slot="'transportationFoList'" slot-scope="scope">
                <div
                  v-for="item in scope.row.transportFile || []"
                  :key="item.aliOssId || item.ossId"
                >
                  <a class="mr-8" :href="item.url" target="_blank">{{
                    item.fileName
                  }}</a>
                </div>
              </template>
            </Table>
          </div>
          <h3>节点/验收报告</h3>
          <div class="info-item">
            <div class="label">附件:</div>
            <div class="value">
              <div
                class="mb-16"
                v-for="item in dataSource.acceptanceFileList || []"
                :key="item.ossId"
              >
                <a :href="item.url" target="_blank">{{ item.fileName }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Upload from "../component/upload.vue";
import Table from "../component/table.vue";
import { reportTableConfig, costTableConfig } from "./help";
import tableTotal from "@/utils/tableTotal";

export default {
  components: {
    Upload,
    Table,
  },
  data() {
    return {
      id: "",
      dataSource: {},
      tableTotal: {
        "工时(小时)": "",
        "工时(人/天)": "",
      },
      tableTotal2: {
        交通费: "money",
      },
    };
  },
  computed: {
    reportTableConfig() {
      const config = { ...reportTableConfig };
      const params = [...config.params];
      params.splice(params.length - 1, 1);
      config.params = params;
      config.summaryMethod = this.getSummaries; // 统计方法
      config.showSummary = true;
      return config;
    },
    costTableConfig() {
      const config = { ...costTableConfig };
      const params = [...config.params];
      params.splice(params.length - 1, 1);
      // 交通费不用插槽
      params[1] = { ...params[1], isSlot: false };

      config.params = params;
      config.summaryMethod = this.getSummaries2; // 统计方法
      config.showSummary = true;
      return config;
    },
  },
  created() {
    this.id = this.$route.query.id;
    this.getDataSource();
  },
  methods: {
    onEdit() {
      this.$router.push({
        name: "ecologicalServices-settlement-edit",
        query: { id: this.id },
      });
    },
    // status 申请传'1' 作废传'0'
    onSubmit(status) {
      this.$http
        .post(`/front/oms/omsSsoSupplierSettle/submit`, { id: this.id, status })
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.$message.success("提交成功");
            // 刷新数据
            this.getDataSource();
          }
        });
    },
    getDataSource() {
      this.$http
        .post(
          `/front/oms/omsSsoSupplierSettle/supplierSettleDetailById/${this.id}`
        )
        .then(({ data: res }) => {
          const { code, data } = res;
          if (code === 0) {
            this.dataSource = data;
            this.$refs.reportTable.setFrontPage(data.itemVoList || []);
            this.$refs.costTable.setFrontPage(data.transportVoList || []);
          }
        });
    },
    toEcology() {
      this.$router.push({ name: "ecologicalServices" });
    },
    toList() {
      this.$router.push({ name: "ecologicalServices-settlement-list" });
    },
    getSummaries(param) {
      return tableTotal(param, this.tableTotal);
    },
    getSummaries2(param) {
      return tableTotal(param, this.tableTotal2);
    },
  },
};
</script>
<style lang="scss" scoped>
.page {
}

.content {
  background: #fff;
  padding: 20px;
  min-height: 800px;
}

h2 {
  font-family: Alibaba PuHuiTi;
  font-size: 20px;
  font-weight: 600;
  color: #1a1a1a;
  margin-top: 0;
}

h3 {
  font-family: Alibaba PuHuiTi;
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
}

.el-button--primary {
  background-color: #2a54d1;
  border-color: #2a54d1;

  &:hover {
    opacity: 0.9;
  }
}

.title {
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}

.label {
  font-family: Alibaba PuHuiTi;
  font-size: 14px;
  text-align: right;
  color: #666666;
  padding-right: 8px;
  width: 100px;
}

.value {
  flex: 1;
  font-family: Alibaba PuHuiTi;
  font-size: 14px;
  font-weight: 600;
  color: #333333;
}

.flex {
  display: flex;
}

.info-item {
  display: flex;
  margin-bottom: 20px;

  a {
    font-family: Alibaba PuHuiTi;
    font-size: 14px;
    font-weight: 600;
    text-align: right;
    color: #2a54d1;
  }
}

.mb-16 {
  margin-bottom: 16px;
}

.bold-tag {
  border-radius: 4px;
  padding: 6.5px 18px;
  background: #2a54d1;
  display: inline-block;
  font-family: AlibabaPuHuiTi;
  font-size: 14px;
  color: #ffffff;
}

.inline-item {
  width: 300px;
}

.tag {
  border-radius: 14px;
  padding: 2px 8px;

  font-family: Alibaba PuHuiTi;
  font-size: 12px;
  font-weight: normal;
  color: #ffffff;
  margin-left: 12px;
}

//  1. 待提审 2. 审批中 3. 已驳回 4. 已生效 5.已取消
.tag1 {
  background: #e5a92f;
}

.tag2 {
  background: #2a54d1;
}

.tag3 {
  background: #e93037;
}

.tag4 {
  background: #1fbd13;
}

.tag5 {
  background: #eee;
  color: #000;
}

.between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
